import { createLogic } from "redux-logic";
import { getEventLookup, getLookup } from "../../../data/api";
import { handleErrors } from "../../../data/helpers";
import { removeLocal, LOCAL_STORAGE_KEYS } from "../../../data/localStorageHelpers";
import { setInlineError } from "../../AppState/actions";
import { setLookups } from "../actions";
import { PostAttendeeActionsActionTypes } from "../types";
var getLookupsLogic = createLogic({
    type: PostAttendeeActionsActionTypes.GET_LOOKUPS,
    latest: true,
    process: function (_a, dispatch, done) {
        var action = _a.action, getState = _a.getState;
        var localAction = action;
        var events = getState().events;
        if (localAction.payload.eventNumber) {
            getEventLookup(localAction.payload.lookupId, localAction.payload.eventNumber)
                .then(function (_a) {
                var _b, _c, _d;
                var data = _a.data;
                if (data && (data.past.length > 0 || data.upcoming.length > 0)) {
                    dispatch(setLookups(data));
                }
                else {
                    dispatch(setInlineError({
                        lookupError: "No Orders, ".concat((_c = (_b = events.event) === null || _b === void 0 ? void 0 : _b.verbiage) !== null && _c !== void 0 ? _c : "Tickets", ", or Groups for that email address"),
                    }));
                    dispatch(setLookups({ upcoming: [], past: [], email: (_d = data.email) !== null && _d !== void 0 ? _d : "" }));
                }
            })
                .catch(function (err) {
                var _a, _b, _c, _d, _e, _f;
                if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    dispatch(setInlineError({
                        lookupError: "No Orders, ".concat((_c = (_b = events.event) === null || _b === void 0 ? void 0 : _b.verbiage) !== null && _c !== void 0 ? _c : "Tickets", ", or Groups for that email address"),
                    }));
                }
                else {
                    dispatch(setInlineError({ lookupError: (_f = (_e = (_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "Lookup not found" }));
                }
                handleErrors(err, dispatch);
                removeLocal(LOCAL_STORAGE_KEYS.LOOKUP_ID);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                dispatch(setLookups(undefined));
            })
                .finally(function () {
                done();
            });
        }
        else {
            getLookup(localAction.payload.lookupId)
                .then(function (_a) {
                var data = _a.data;
                dispatch(setLookups(data));
            })
                .catch(function (err) {
                var _a, _b, _c, _d;
                if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    dispatch(setInlineError({ lookupError: "No events found for that email address" }));
                }
                else {
                    dispatch(setInlineError({ lookupError: (_d = (_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "Lookup not found" }));
                }
                handleErrors(err, dispatch);
                removeLocal(LOCAL_STORAGE_KEYS.LOOKUP_ID);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                dispatch(setLookups(undefined));
            })
                .finally(function () {
                done();
            });
        }
    },
});
var exportable = [getLookupsLogic];
export default exportable;
